import { BondInsuranceInvoiceStatusEnum } from '../../services/bond-insurance-invoices';

import { BondInsuranceInvoiceFiltersState } from './types';

export const bondInsuranceInvoicesLabel = 'Faturas de fiança';

export const initialFilters: BondInsuranceInvoiceFiltersState = {
  estateId: '',
  estateUnitId: '',
  insurerId: '',
  accountManager: '',
  status: '',
  start: '',
  end: ''
};

export const statusOptions = [
  { key: BondInsuranceInvoiceStatusEnum.OPEN, value: BondInsuranceInvoiceStatusEnum.OPEN, text: 'Aberta' },
  { key: BondInsuranceInvoiceStatusEnum.CLOSED, value: BondInsuranceInvoiceStatusEnum.CLOSED, text: 'Fechada' },
  { key: BondInsuranceInvoiceStatusEnum.CANCELED, value: BondInsuranceInvoiceStatusEnum.CANCELED, text: 'Cancelada' }
];

export const statusLabelMap: Record<string, string> = {
  [BondInsuranceInvoiceStatusEnum.OPEN]: 'Aberta',
  [BondInsuranceInvoiceStatusEnum.CLOSED]: 'Fechada',
  [BondInsuranceInvoiceStatusEnum.CANCELED]: 'Cancelada'
};
